'use client'

import { useState } from 'react'
import ChevronDownButton from '@/assets/images/ChevronDownButton.svg'
import { FORM_TYPES } from '@/constants/contact'
import { useTranslation } from 'react-i18next'
import { motion, AnimatePresence } from 'framer-motion'
import TypeModalItem from '@/app/contact/_components/TypeModalItem'

type ITypeModalProps = {
  type: string
  setType: React.Dispatch<React.SetStateAction<string>>
}

const TypeModal = ({ type, setType }: ITypeModalProps) => {
  const { t } = useTranslation('contact')

  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleSelectType = (type: string) => {
    setType(type)
    setIsModalOpen(false)
  }

  const handleButtonClick = (e: React.MouseEvent) => {
    e.preventDefault()
    setIsModalOpen((prev) => !prev)
  }
  return (
    <div className="relative">
      <div className="mx-5">
        <button
          type="button"
          onClick={handleButtonClick}
          className="w-full flex items-center justify-between bg-secondary text-primary rounded-[12px] py-4 px-5"
        >
          {t(`contact_category.${type}`)}
          <ChevronDownButton />
        </button>
      </div>

      <AnimatePresence>
        {isModalOpen && (
          <>
            {/* 모바일 환경에서는 바텀시트로 */}
            <div className="sm:hidden">
              <motion.div
                className="fixed inset-0 bg-black bg-opacity-50 z-10"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                onClick={() => setIsModalOpen(false)}
              ></motion.div>

              <motion.div
                initial={{ y: '100%', opacity: 0 }}
                animate={{ y: '0%', opacity: 1 }}
                exit={{ y: '100%', opacity: 0 }}
                transition={{ type: 'spring', stiffness: 150, damping: 25 }}
                className="fixed bottom-0 w-full z-20 rounded-t-3xl rounded-b-none bg-white dark:bg-black py-1"
              >
                <p className="font-pretendard-bold text-[28px] tracking-[-0.02em] text-main-light-1 dark:text-main-dark-1 px-4 mt-8 mb-3">
                  {t('contact_type')}
                </p>
                <ul className="flex flex-col max-h-[70vh] overflow-y-auto">
                  {FORM_TYPES.map((type) => (
                    <TypeModalItem
                      key={type.id}
                      type={type}
                      onSelect={handleSelectType}
                    />
                  ))}
                </ul>
              </motion.div>
            </div>

            {/* 데스크톱 환경에서는 드롭다운으로 */}
            <div className="hidden sm:block mx-5 relative">
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="absolute bg-white dark:bg-black shadow-lg rounded-lg mt-2 z-20 w-full"
              >
                <ul className="flex flex-col">
                  {FORM_TYPES.map((type) => (
                    <TypeModalItem
                      key={type.id}
                      type={type}
                      onSelect={handleSelectType}
                    />
                  ))}
                </ul>
              </motion.div>
            </div>
          </>
        )}
      </AnimatePresence>
    </div>
  )
}

export default TypeModal
